import { ModuleConfig } from "../../types/ModuleConfig";

/**
 * Authentication Module Config
 *
 * This module is consumed via `./index.ts` exports (UnifiedLoginModal,
 * SecureMembershipButton, AuthContext queries, etc.) rather than by
 * registering routes/nav. The moduleConfig exists only so the cross-tenant
 * drift scanner can read a version string and track this module alongside
 * the route-based modules on the Module Upgrade Matrix.
 *
 * Integration guide: see ./CLAUDE.md
 */
const authenticationModuleConfig: ModuleConfig = {
    id: "authentication",
    name: "Authentication",
    description: "Unified login + SMS/email verification + username/password + myClient AuthContext",
    version: "1.3.0", // Two-step verification: session assurance (aal/amr) in the token, step-up dialog, /security card.
    enabled: true,
    category: "core",
    order: 0,
    icon: "🔐",
    navigation: [],
    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },
    routes: [],
    changelog: [
        {
            version: "1.3.0",
            releaseDate: "2026-09-26",
            title: "Two-step verification (step-up)",
            features: [
                "Security page: a Two-step verification card — status in words, the sign-in methods you have set up, Turn on (only when two different methods are set up), Turn off, New recovery codes",
                "Recovery codes shown once, with Copy, Download .txt and \"I've saved them\"",
                "\"Confirm it's you\" step-up dialog: passkey, password, email code, text code or a recovery code",
                "useStepUp() hook and RequireTwoFactor page wrapper for future secure pages",
                "AuthContext (shared file) gains assurance + adoptToken — additive, the existing API is unchanged",
                "Profile Settings: the old two-factor switch (never enforced) is replaced by a link to the Security page",
            ],
            notes: "Needs a backend with myTwoFactorStatus and the step-up mutations. Sign-in itself is unchanged; nothing is forced.",
        },
    ],
};

export default authenticationModuleConfig;
